/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotebookSpanSchema
 */
export interface NotebookSpanSchema {
    /**
     * 
     * @type {Date}
     * @memberof NotebookSpanSchema
     */
    start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NotebookSpanSchema
     */
    stop?: Date;
    /**
     * 
     * @type {Array<object>}
     * @memberof NotebookSpanSchema
     */
    callstack?: Array<object>;
    /**
     * 
     * @type {number}
     * @memberof NotebookSpanSchema
     */
    ident: number;
}

/**
 * Check if a given object implements the NotebookSpanSchema interface.
 */
export function instanceOfNotebookSpanSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ident" in value;

    return isInstance;
}

export function NotebookSpanSchemaFromJSON(json: any): NotebookSpanSchema {
    return NotebookSpanSchemaFromJSONTyped(json, false);
}

export function NotebookSpanSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotebookSpanSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'start': !exists(json, 'start') ? undefined : (new Date(json['start'])),
        'stop': !exists(json, 'stop') ? undefined : (new Date(json['stop'])),
        'callstack': !exists(json, 'callstack') ? undefined : json['callstack'],
        'ident': json['ident'],
    };
}

export function NotebookSpanSchemaToJSON(value?: NotebookSpanSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'start': value.start === undefined ? undefined : (value.start.toISOString()),
        'stop': value.stop === undefined ? undefined : (value.stop.toISOString()),
        'callstack': value.callstack,
        'ident': value.ident,
    };
}

